import React,{useState,useEffect} from 'react'
import {useSelector} from 'react-redux'
import Fade from 'react-reveal'
import {
    Button,
    Tooltip
} from 'antd'
import  {
DollarCircleOutlined
} from '@ant-design/icons'
import {ReactComponent  as Coins} from './coins.svg'
import CountUp from 'react-countup';

export default function Rewards(props) {
    const user = useSelector(state=>state.user)
    const [canRedeem,setCanRedeem] = useState(false)
   useEffect(()=>{
    if(user.coins>=10000){
        setCanRedeem(true)
    }else setCanRedeem(false)
   },[])
    return (
        <Fade right>
            <div id="rewards-menu">
            {props.note?<h1 style={{color:"#40a9ff"}}>Coins Balance</h1>:null}
             
            <span style={{fontSize:"40px"}}>
            
            <Coins/>
            </span>
                 <span id="coins"><CountUp duration={2} start={user.coins-100} end={user.coins} />
                 <span className="coins-logo-gold"><DollarCircleOutlined/></span></span>

                 {props.note?
                    <Tooltip title={!canRedeem?"Insufficient Coins Balance!":"Great ! You can redeem your coins"}
                 
                 color={!canRedeem?"red":"green"} key={!canRedeem?"red":"green"}>
                    <Button disabled={!canRedeem}> REDEEM COINS</Button>
                 </Tooltip>:
                    null
                    }
                
                <br/>
                {props.note?
                <p style={{color:"gray",fontSize:"20px"}}> You need {10000-user.coins} more coins to redeem</p>:
                null
                }
            </div>
        </Fade>
    )
}
